/* Copyright 2012-2019 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the events associated with it. This
 * information is used in order to dispatch the correct events to the peer model. This is also used
 * to map events to actions registered with the action service.
 */

define(["../constants/TypeConstants"],
    function (TypeConstants) {
        var hash = {};

        hash[TypeConstants.TOOLSTRIP] = {
            actionEvents: [],
            componentEvents: ["toolstripPlaced"]
        };

        hash[TypeConstants.TAB] = {
            actionEvents: [],
            componentEvents: ["remove"]
        };

        hash[TypeConstants.PUSH_BUTTON] = {
            actionEvents: ["buttonPushed"],
            componentEvents: []
        };

        hash[TypeConstants.QAB] = {
            actionEvents: [],
            componentEvents: ["restoreFactoryControls", "controlAdded", "controlRemoved"]
        };

        hash[TypeConstants.QAB_PUSH_BUTTON] = hash[TypeConstants.PUSH_BUTTON];

        hash[TypeConstants.TOGGLE_BUTTON] = {
            actionEvents: [],
            componentEvents: []
        };

        hash[TypeConstants.QAB_TOGGLE_BUTTON] = hash[TypeConstants.TOGGLE_BUTTON];

        hash[TypeConstants.DROP_DOWN_BUTTON] = {
            actionEvents: [],
            componentEvents: ["dropDownPerformed"]
        };

        hash[TypeConstants.QAB_DROP_DOWN_BUTTON] = hash[TypeConstants.DROP_DOWN_BUTTON];

        hash[TypeConstants.SPLIT_BUTTON] = {
            actionEvents: ["buttonPushed"],
            componentEvents: ["dropDownPerformed"]
        };

        hash[TypeConstants.COLOR_PICKER_BUTTON] = {
            actionEvents: ["valueChanged"],
            componentEvents: []
        };

        hash[TypeConstants.QAB_SPLIT_BUTTON] = hash[TypeConstants.SPLIT_BUTTON];

        hash[TypeConstants.TOGGLE_SPLIT_BUTTON] = {
            actionEvents: [],
            componentEvents: ["dropDownPerformed"]
        };

        hash[TypeConstants.QAB_TOGGLE_SPLIT_BUTTON] = hash[TypeConstants.TOGGLE_SPLIT_BUTTON];


        hash[TypeConstants.COMBO_BOX] = {
            actionEvents: ["dropDownPerformed", "focusGained", "focusLost", "typing", "textCancelled", "recommit"],
            componentEvents: []
        };

        hash[TypeConstants.POPUP_LIST] = {
            actionEvents: [],
            componentEvents: ["onOpen", "onClose"]
        };

        hash[TypeConstants.LIST_ITEM] = {
            actionEvents: ["itemPushed"],
            componentEvents: ["remove"]
        };

        hash[TypeConstants.LIST_ITEM_WITH_POPUP] = {
            actionEvents: [],
            componentEvents: ["dropDownPerformed"]
        };

        hash[TypeConstants.LIST_ITEM_WITH_CHECKBOX] = {
            actionEvents: [],
            componentEvents: ["closeRequest"]
        };

        hash[TypeConstants.TEXT_FIELD] = {
            actionEvents: ["focusGained", "focusLost", "typing", "textCancelled", "recommit"],
            componentEvents: []
        };

        hash[TypeConstants.TEXT_AREA] = {
            actionEvents: ["focusGained", "focusLost"],
            componentEvents: []
        };

        hash[TypeConstants.LIST_ITEM_WITH_TEXTFIELD] = {
            actionEvents: ["focusGained", "focusLost", "typing", "commit", "recommit", "textCancelled", "itemPushed"],
            componentEvents: ["remove", "edit"]
        };

        hash[TypeConstants.HORIZONTAL_SLIDER] = {
            actionEvents: ["valueChanged"],
            componentEvents: []
        };

        hash[TypeConstants.SPINNER] = {
            actionEvents: ["valueChanged", "recommit"],
            componentEvents: []
        };

        hash[TypeConstants.GALLERY] = {
            actionEvents: [],
            componentEvents: ["refresh"]
        };

        hash[TypeConstants.GALLERY_POPUP] = {
            actionEvents: [],
            componentEvents: ["galleryStateChanged"]
        };

        hash[TypeConstants.GALLERY_PANEL] = {
            actionEvents: [],
            componentEvents: ["galleryStateChanged"]
        };

        hash[TypeConstants.GALLERY_CATEGORY] = {
            actionEvents: [],
            componentEvents: ["categoryMoved", "itemMoved"]
        };

        hash[TypeConstants.GALLERY_FAVORITE_CATEGORY] = {
            actionEvents: [],
            componentEvents: ["itemMoved"]
        };

        hash[TypeConstants.GALLERY_ITEM] = {
            actionEvents: ["itemPushed"],
            componentEvents: ["favButtonPushed", "remove"]
        };

        hash[TypeConstants.TOGGLE_GALLERY_ITEM] = {
            actionEvents: [],
            componentEvents: ["favButtonPushed", "remove"]
        };

        hash[TypeConstants.QA_GROUP] = {
            actionEvents: [],
            componentEvents: ["itemMoved"]
        };

        // Special Controls:
        hash[TypeConstants.SPLIT_BUTTON_WITH_DISABLE_OVERRIDE] = hash[TypeConstants.SPLIT_BUTTON];

        return hash;
    });